<template>
	<div v-if="isLogged">
		<ul v-if="role == 1">
			<router-link tag="li" active-class="active" :to="{ name : 'admin.dashboard'}"><a>Dashboard</a></router-link>
			<router-link tag="li" active-class="active" :to="{ name : 'admin.organizations.index' }"><a>Organizations</a></router-link>
			<router-link tag="li" active-class="active" :to="{ name : 'admin.smes.index' }"><a>SMEs</a></router-link>
			<router-link tag="li" active-class="active" :to="{ name : 'admin.providers.index' }"><a>Employees</a></router-link>
			<li @click="logout()"><a>Logout</a></li>
		</ul>

		<ul v-if="role == 3">
			<router-link tag="li" active-class="active" :to="{ name : 'organization.dashboard'}"><a>Dashboard</a></router-link>
			<router-link tag="li" active-class="active" :to="{ name : 'organization.providers.index' }"><a>Providers</a></router-link>
			<li @click="logout()"><a>Logout</a></li>
		</ul>

		<ul v-if="role == 4">
			<router-link tag="li" active-class="active" :to="{ name : 'sme.dashboard'}"><a>Dashboard</a></router-link>
			<router-link tag="li" active-class="active" :to="{ name : 'sme.courses.index' }"><a>Courses</a></router-link>
			<li @click="logout()"><a>Logout</a></li>
		</ul>
	</div>
</template>


<script>
export default{
	computed : {
		isLogged : function(){
			return this.$store.getters.isLogged;
		},
		role : function() {
			return this.$store.getters.getRole;
		}
	},

	methods : {
		logout : function(){
			this.$store.dispatch('logout', { router : this.$router });
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/shared/MenuComponent.vue